module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__inFrontOfAccent--dark-948a1ccbaa3879f0da8e7216492b2ce6.png";